import { render, staticRenderFns } from "./UserAddress.vue?vue&type=template&id=4a5d6a48&scoped=true&"
import script from "./UserAddress.vue?vue&type=script&lang=js&"
export * from "./UserAddress.vue?vue&type=script&lang=js&"
import style0 from "./UserAddress.vue?vue&type=style&index=0&id=4a5d6a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d6a48",
  null
  
)

export default component.exports